import { render } from "./KpabgCyanoPrintPage.vue?vue&type=template&id=56be3b5c&scoped=true"
import script from "./KpabgCyanoPrintPage.vue?vue&type=script&lang=js"
export * from "./KpabgCyanoPrintPage.vue?vue&type=script&lang=js"

import "./KpabgCyanoPrintPage.vue?vue&type=style&index=0&id=56be3b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56be3b5c"]])

export default __exports__